/**
 * External dependencies
 */
import {
	withBlockStyles,
	withUniqueClass,
} from '~cartzillagb/higher-order'

import {
	BlockContainer,
	ButtonEditHelper
} from '~cartzillagb/components'

import classnames from 'classnames'
import createStyles from './style'

/**
 * WordPress dependencies
 */
import { Fragment } from '@wordpress/element'
import { applyFilters } from '@wordpress/hooks'
import {
	InnerBlocks,
	RichText
} from '@wordpress/block-editor'
import { compose } from '@wordpress/compose'

const save = props => {
	const {
		className,
		attributes,
	} = props

	const {
		uniqueClass,
		enableContainer,

		// Title.
		showTitle = true,
		title = '',
		titleTag = 'h3',

		// Button.
		showHeaderButton = false,
		headerButtonText,

		showFooterButton = false,
		footerButtonText,
	} = attributes

	const mainClasses = classnames( [
		'czgb-products-with-header-block',
		className,
		enableContainer ? 'container' : '',
	], applyFilters( 'cartzillagb.products-with-header.main-block.classes', {}, props ) )

	const titleComp = showTitle &&
		<RichText.Content
			tagName={ titleTag || 'h3' }
			value={ title }
			className={ classnames( [
				'czgb-products-with-header__title',
				showHeaderButton ? 'h3 mb-0 pt-3 mr-2' : 'h3 text-center',
			] ) }
		/>

	const headerButtonComp = showHeaderButton && ! RichText.isEmpty( headerButtonText ) &&
		<ButtonEditHelper.Content
			attrNameTemplate={ `headerButton%s` }
			blockAttributes={ props.attributes }
		/>

	const footerButtonComp = showFooterButton && ! RichText.isEmpty( footerButtonText ) &&
		<ButtonEditHelper.Content
			attrNameTemplate={ `footerButton%s` }
			blockAttributes={ props.attributes }
		/>

	const headerComp = showTitle && showHeaderButton ? (
		<div className="czgb-products-with-header__header d-flex flex-wrap justify-content-between align-items-center pt-1 border-bottom pb-4 mb-4" >
			{ titleComp }
			<div className="pt-3" >
				{ headerButtonComp }
			</div>
		</div>
	) : ( showTitle ? (
		titleComp
	) : ( showHeaderButton ? (
		<div className="czgb-products-with-header__header d-flex flex-wrap justify-content-between align-items-center pt-1 border-bottom pb-4 mb-4" >
			{ headerButtonComp }
		</div>
	) : '' ) )

	const footerComp = showFooterButton && (
		<div className="czgb-products-with-header__footer text-center pt-3" >
			{ footerButtonComp }
		</div>
	)

	const wraperAttr = {}

	if( ! showHeaderButton ) {
		wraperAttr.className = 'pt-4'
	}

	return (
		<BlockContainer.Save className={ mainClasses } blockProps={ { ...props, attributes:{ ...props.attributes, anchor: uniqueClass } } } render={ () => (
			<Fragment>
				{ headerComp }
				<div { ...wraperAttr }>
					<InnerBlocks.Content />
				</div>
				{ footerComp }
			</Fragment>
		) } />
	)
}

export default compose(
	withUniqueClass,
	withBlockStyles( createStyles ),
)( save )